<template>
  <b-card>
    <FormBuilder
      label="Kategori"
      update
      :data="$store.getters['categoryV2/detailData']"
      :fields="fields"
      :loading-detail="$store.state.categoryV2.loadingDetail"
      :loading-submit="$store.state.categoryV2.loadingSubmit"
      @load="loadData"
      @submit="submitData"
      @reset="resetData"
    />
  </b-card>
</template>

<script>
import FormBuilder from '@/layouts/components/v2/FormBuilder.vue'
import { BCard } from 'bootstrap-vue'
import baseFields from '@/field/form/category'

export default {
  components: {
    BCard,
    FormBuilder,
  },
  computed: {
    // Edit: photo optional, replace-only. Create still requires it.
    fields() {
      return baseFields.map(field => (field.key === 'media_id'
        ? { ...field, required: false, notes: ['Mengunggah foto baru akan mengganti foto lama. Foto tidak dapat dihapus, hanya diganti.'] }
        : field))
    },
  },
  methods: {
    loadData(id) {
      return this.$store.dispatch('categoryV2/getDetail', id)
    },
    submitData(id, data, callback) {
      this.$store.dispatch('categoryV2/update', { id, data })
        .then(() => {
          if (typeof callback === 'function') callback()
        })
        .catch(err => callback(err))
    },
    resetData() {
      this.$store.commit('categoryV2/SET_DETAIL_DATA', undefined)
    },
  },
}
</script>
